import type { ErrorCatalog } from "@mk/shared";

export const trErrors = {
  generic: () => "İşlem tamamlanamadı",
  unauthorized: () => "Giriş yapman gerekiyor",
  rate_limited: () => "Çok fazla istek gönderdin. Biraz bekleyip tekrar dene.",
  invalid_request: () => "Geçersiz istek",
  not_found: () => "Bulunamadı",
  server_error: () => "Sunucuda bir şeyler ters gitti",
  invalid_email: () => "Geçerli bir e-posta gir",
  invalid_username: () => "Kullanıcı adı 3-20 karakter olmalı; harf, rakam ve _ kullanabilirsin",
  invalid_password: () => "Şifre en az 8 karakter olmalı",
  missing_login: () => "E-posta ya da kullanıcı adını gir",
  missing_password: () => "Şifreni gir",
  email_taken: () => "Bu e-posta zaten kayıtlı",
  username_taken: () => "Bu kullanıcı adı alınmış",
  username_cooldown: () => "Kullanıcı adını 90 günde bir değiştirebilirsin",
  username_change_busy: () => "Oyun ya da eşleşme sırasında ad değiştirilemez",
  reset_link_invalid: () => "Şifre bağlantısı geçersiz ya da süresi dolmuş",
  recovery_unavailable: () => "Hesap kurtarma şu an kullanılamıyor",
  account_create_failed: () => "Hesap oluşturulamadı",
  invalid_credentials: () => "E-posta/kullanıcı adı ya da şifre hatalı",
  google_disabled: () => "Google ile giriş şu an kapalı",
  google_response_invalid: () => "Google yanıtı okunamadı",
  google_verification_invalid: () => "Google doğrulaması geçersiz",
  google_session_expired: () => "Süre doldu, Google ile tekrar dene",
  session_expired: () => "Oturumun sona ermiş, tekrar giriş yap",
  account_not_found: () => "Hesap bulunamadı",
  wrong_password: () => "Şifre hatalı",
  google_verification_failed: () => "Google doğrulaması yapılamadı",
  apple_disabled: () => "Apple ile giriş şu an kapalı",
  apple_response_invalid: () => "Apple yanıtı okunamadı",
  apple_verification_invalid: () => "Apple doğrulaması geçersiz",
  apple_session_expired: () => "Süre doldu, Apple ile tekrar dene",
  apple_verification_failed: () => "Apple doğrulaması yapılamadı",
  invalid_friendship: () => "Geçersiz arkadaşlık",
  friendship_not_found: () => "Arkadaşlık bulunamadı",
  invalid_user: () => "Geçersiz kullanıcı",
  cannot_add_self: () => "Kendini ekleyemezsin",
  already_friends: () => "Zaten arkadaşsınız",
  friend_request_already_sent: () => "İstek zaten gönderilmiş",
  friend_request_not_found: () => "İstek bulunamadı",
  missing_friendship_id: () => "Arkadaşlık kimliği eksik",
  friend_not_found: () => "Arkadaş bulunamadı",
  guess_missing: () => "Tahmin gönderilmedi",
  daily_finished: () => "Bugünün oyunu bitti",
  invalid_word_length: ({ length }) => `${length} harf gerekiyor`,
  word_not_in_list: () => "Bu kelime listede yok",
  stale_guess: () => "Tahtan başka bir gönderimle ilerledi; güncel hâli yüklendi",
  match_unavailable: () => "Maç bulunamadı ya da bitti",
  match_not_found: () => "Maç bulunamadı",
  not_in_match: () => "Bu maçta değilsin",
  match_not_started: () => "Maç henüz başlamadı",
  time_expired: () => "Süre doldu",
  turn_finished: () => "Senin için maç bitti",
  finish_own_turn_first: () => "Önce kendi turunu bitirmelisin",
  opponent_turn_finished: () => "Rakibinin turu zaten bitti",
  rematch_too_old: () => "Bu maç rövanş için fazla eski",
  not_played_match: () => "Bu maçta oynamadın",
  opponent_not_found: () => "Rakip bulunamadı",
  active_match_exists: () => "Zaten devam eden bir maçın var",
  opponent_in_match: () => "Rakibin başka bir maçta",
  friend_in_match: () => "Arkadaşın şu an başka bir maçta",
  participant_in_match: () => "Taraflardan biri şu an başka bir maçta",
  opponent_offline: () => "Rakibin çevrimdışı",
  opponent_went_offline: () => "Rakibin çevrimdışı oldu",
  mutual_rematch_pending: () => "Rakibin de rövanş istedi, teklifini kabul et",
  rematch_not_found: () => "Rövanş teklifi bulunamadı",
  cannot_challenge_self: () => "Kendine meydan okuyamazsın",
  friends_required: () => "Önce arkadaş olmanız gerekiyor",
  invalid_match_rules: () => "Geçersiz maç ayarları",
  challenge_pending: ({ seconds }) => `Bu arkadaşına gönderdiğin davet duruyor (${seconds} sn)`,
  challenge_cooldown: ({ seconds }) => `Yeni davet için ${seconds} saniye beklemelisin`,
  challenge_create_failed: () => "Meydan okuma oluşturulamadı",
  challenge_not_found: () => "Meydan okuma bulunamadı",
  challenge_expired: () => "Meydan okumanın süresi dolmuş",
  too_fast: () => "Çok hızlı gidiyorsun, bir saniye bekle",
  cannot_spectate_own_match: () => "Kendi maçını izleyemezsin",
  cannot_spectate_during_match: () => "Devam eden maçın varken başka maç izleyemezsin",
  friends_only_spectate: () => "Yalnızca arkadaşlarının maçını izleyebilirsin",
  spectate_start_failed: () => "İzleme başlatılamadı",
  opponent_watch_failed: () => "Rakip izlenemedi",
  match_start_failed: () => "Eşleşme başlatılamadı",
  guess_process_failed: () => "Tahmin işlenemedi",
  forfeit_failed: () => "Maç terk edilemedi",
  challenge_send_failed: () => "Meydan okuma gönderilemedi",
  challenge_response_failed: () => "Meydan okuma yanıtlanamadı",
  challenge_cancel_failed: () => "Meydan okuma iptal edilemedi",
  rematch_response_failed: () => "Rövanş yanıtlanamadı",
  rematch_expired: () => "Rövanş teklifinin süresi doldu",
  opponent_left: () => "Rakibin ayrıldı",
  team_lobby_not_found: () => "2v2 lobisi bulunamadı",
  team_lobby_full: () => "Lobi dolu",
  team_lobby_kicked: () => "Bu lobiden çıkarıldın",
  team_lobby_host_only: () => "Bu işlemi yalnız lobi kurucusu yapabilir",
  team_lobby_not_ready: () => "Maç için dört bağlı oyuncu ve 2–2 takım dağılımı gerekiyor",
  team_spectators_disabled: () => "Bu lobide izleyicilere izin verilmiyor",
  team_match_not_found: () => "2v2 maçı bulunamadı",
  team_match_finished: () => "2v2 maçı sona erdi",
  team_transition_pending: () => "Sonraki kelime hazırlanıyor",
} satisfies ErrorCatalog;
